import { Fragment, useRef, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Select, Button, MultiSelect } from "@mantine/core";
import { FiUpload } from "react-icons/fi";
import { useTheme } from "../../../ThemeContext";
import { read, utils } from "xlsx";
import Papa from "papaparse";
import ProjectNames from "../../Dropdowns/ProjectNames";
import { addQualityInspection, updateQualityInspection } from '../../../api/api';
import ProjectManager from '../../Dropdowns/ProjectManagers';
import {formatedDate} from '../../../api/services'
const QualityInspectionForm = ({ isOpen, onClose, edit, editData, handleUpdate ,setEdit}) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const cancelButtonRef = useRef(null);
  const [checklists, setChecklists] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [pname, setPname] = useState('');
  const [manager, setManager] = useState('');
  console.log(editData);
  const initialValues = edit ? {
    inspectionRequest: editData.inspectionRequest,
    comments: editData.comment,
    submissionDate: formatedDate(editData.submissionDate),
    status: editData.status,
    checklistFile: editData.checklistFile
  } : {
    inspectionRequest: "",
    comments: "",
    submissionDate: "",
    status: "",
    checklistFile: null
  };

  useEffect(() => {
    if (edit) {
      setPname(editData.projectId._id);
      setManager(editData.contractorName._id);
      setSelectedItems(editData.checkList || []);
    }
  }, [edit]);

  const [formValues, setFormValues] = useState(initialValues);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFileName(file.name);

    try {
      const fileType = file.name.split(".").pop().toLowerCase();

      if (fileType === "csv") {
        Papa.parse(file, {
          header: true,
          complete: (result) => {
            const parsedData = result.data.map((row, index) => ({
              value: row.id || `item-${index}`,
              label: row.name || `Item ${index}`,
            }));
            setChecklists(parsedData);
          },
          error: (error) => console.error("Error parsing CSV:", error),
        });
      } else if (["xls", "xlsx"].includes(fileType)) {
        const data = await file.arrayBuffer();
        const workbook = read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const parsedData = utils.sheet_to_json(sheet).map((row, index) => ({
          value: row.id || `item-${index}`,
          label: row.name || `Item ${index}`,
        }));
        setChecklists(parsedData);
      } else {
        console.error("Unsupported file type");
      }
    } catch (err) {
      console.error("Error parsing file:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("projectId", pname);
      formData.append("submissionDate", formValues.submissionDate);
      formData.append("contractorName", manager);
      formData.append("inspectionRequest", formValues.inspectionRequest);
      formData.append("comment", formValues.comments);
      formData.append("status", formValues.status);
      formData.append("checkList", JSON.stringify(selectedItems));
      if(edit){
        formData.append("inspectionId", editData._id);
      }

      if (formValues.checklistFile) {
        formData.append("checklistFile", formValues.checklistFile);
      }

      const res = edit ? await updateQualityInspection(formData) : await addQualityInspection(formData);
      if (res) {
        onClose();
        setEdit(false)
        handleUpdate();
      }
      console.log(res);
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-md ${isDark ? "bg-gray-800 text-white" : "bg-white text-gray-900"
                  } text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg`}
              >
                <div className="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                      <Dialog.Title as="h3" className="text-lg py-4 text-center font-semibold leading-6">
                        {editData ? "Edit Data" : "Add Data"}
                      </Dialog.Title>
                      <form onSubmit={handleSubmit}>
                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 mt-4">
                          <div>
                            <ProjectNames pname={pname} handleChange={e => setPname(e.target.value)} />
                          </div>
                          <div>
                            <ProjectManager projectManager={manager} handleChange={e => setManager(e.target.value)} />
                          </div>

                          <div className="mb-4">
                            <label className="block mb-3 text-sm font-medium">Inspection Request</label>
                            <input
                              type="text"
                              name="inspectionRequest"
                              value={formValues.inspectionRequest}
                              onChange={handleInputChange}
                              placeholder="Describe the inspection request"
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""
                                }`}
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium mb-3">Upload Checklist</label>
                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="fileInput"
                                className={`w-full flex items-center justify-start gap-2 p-2 rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${isDark ? "bg-gray-700 text-white border-gray-300" : ""
                                  }`}
                              >
                                {selectedFileName ? (
                                  <span className="text-md text-gray-600 truncate max-w-md">{selectedFileName}</span>
                                ) : (
                                  <>
                                    <FiUpload className="h-4 w-4" />
                                    <span>Upload File</span>
                                  </>
                                )}
                              </label>
                              <input
                                id="fileInput"
                                type="file"
                                name="checklistFile"
                                onChange={handleFileChange}
                                className="hidden"
                              />
                            </div>
                          </div>

                          <div className="mb-4">
                            <label className="block mb-3 text-sm font-medium">Submission Date</label>
                            <input
                              name="submissionDate"
                              type='date'
                              value={formValues.submissionDate}
                              onChange={handleInputChange}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""
                                }`}
                            />
                          </div>

                          <div className="mb-4">
                            <label className="block mb-3 text-sm font-medium">Status</label>
                            <input
                              name="status"
                              value={formValues.status}
                              onChange={handleInputChange}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""
                                }`}
                            />
                          </div>
                        </div>

                        <div className="mb-4">
                          <label className="block mb-3 text-sm font-medium">Additional Comments</label>
                          <textarea
                            name="comments"
                            value={formValues.comments}
                            onChange={handleInputChange}
                            placeholder="Add any additional comments"
                            className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${isDark ? "bg-gray-700 text-white border-gray-600" : ""
                              }`}
                          />
                        </div>

                        {checklists.length > 0 && (
                          <div className="mb-4">
                            <MultiSelect
                              label="Select Checklist Items"
                              data={checklists}
                              value={selectedItems}
                              onChange={setSelectedItems}
                              placeholder="Select items"
                            />
                          </div>
                        )}

                        <div className="flex justify-between space-x-4">
                          <Button variant="outline" color="gray" onClick={onClose} className="w-full sm:w-auto">
                            Cancel
                          </Button>
                          <Button type="submit" color="blue" className="w-full sm:w-auto">
                            Submit
                          </Button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default QualityInspectionForm;
